import React, { PropTypes } from 'react';
import './index.scss';

const LoaderWithText = React.createClass({
    propTypes: {
        loadingText: PropTypes.string.isRequired
    },
	render: function() {
        const { loadingText } = this.props;
		return <div>
            <div className="spinningCircle"></div>
            <div className="loading-text">{loadingText + '...'}</div>
        </div>;
	}
});

export default LoaderWithText;


// WEBPACK FOOTER //
// ./src/components/common/LoaderWithText/index.jsx